import { ConsolidationMappingFieldType, PipingObjectType } from 'src/app/shared/models/autogenerated-piping';

/**
 * Fixed dropdown options for the Consolidation Mapping admin screen.
 */
export const PIPING_OBJECT_TYPE_OPTIONS: { value: PipingObjectType; label: string }[] = [
  { value: PipingObjectType._1, label: 'Pipe' },
  { value: PipingObjectType._2, label: 'Valve' },
];

export const PIPE_MAPPING_FIELD_TYPE_OPTIONS: { value: ConsolidationMappingFieldType; label: string }[] = [
  { value: ConsolidationMappingFieldType._1, label: 'Primary Service' },
  { value: ConsolidationMappingFieldType._2, label: 'Pressure Rating' },
  { value: ConsolidationMappingFieldType._3, label: 'Material' },
  { value: ConsolidationMappingFieldType._4, label: 'Nominal Corrosion Allowance' },
  { value: ConsolidationMappingFieldType._5, label: 'Valve Trim' },
  { value: ConsolidationMappingFieldType._6, label: 'Stress Relief' },
  { value: ConsolidationMappingFieldType._7, label: 'Examination' },
];

export const VALVE_MAPPING_FIELD_TYPE_OPTIONS: { value: ConsolidationMappingFieldType; label: string }[] = [
  { value: ConsolidationMappingFieldType._8, label: 'Type' },
  { value: ConsolidationMappingFieldType._9, label: 'Pressure Class' },
  { value: ConsolidationMappingFieldType._10, label: 'End Connection' },
  { value: ConsolidationMappingFieldType._11, label: 'Body Material' },
  { value: ConsolidationMappingFieldType._12, label: 'Trim Material' },
];

export const MAPPING_FIELD_TYPE_OPTIONS = [
  ...PIPE_MAPPING_FIELD_TYPE_OPTIONS,
  ...VALVE_MAPPING_FIELD_TYPE_OPTIONS,
];

export function getMappingFieldTypeOptions(pipingObjectType: PipingObjectType | undefined): { value: ConsolidationMappingFieldType; label: string }[] {
  if (pipingObjectType === PipingObjectType._1) {
    return PIPE_MAPPING_FIELD_TYPE_OPTIONS;
  }

  if (pipingObjectType === PipingObjectType._2) {
    return VALVE_MAPPING_FIELD_TYPE_OPTIONS;
  }

  return [];
}

/**
 * Returns the display label for a `PipingObjectType` value, or an empty string
 * if the value doesn't match a known option.
 * @param value The enum value to look up.
 * @returns The matching display label, or `''` when not found.
 */
export function getPipingObjectTypeLabel(value: PipingObjectType): string {
  return PIPING_OBJECT_TYPE_OPTIONS.find(option => option.value === value)?.label ?? '';
}

/**
 * Returns the display label for a `ConsolidationMappingFieldType` value, or an empty string
 * if the value doesn't match a known option.
 * @param value The enum value to look up.
 * @returns The matching display label, or `''` when not found.
 */
export function getMappingFieldTypeLabel(value: ConsolidationMappingFieldType): string {
  return MAPPING_FIELD_TYPE_OPTIONS.find(option => option.value === value)?.label ?? '';
}
